import { defineComponent as _defineComponent } from 'vue'
import CustomerVehicleSelector from './CustomerVehicleSelector.vue';
import SideMenu from 'Src/js/components/SideMenu.vue';
import TransitionFade from 'JS/components/transitions/TransitionFade.vue';
import { ICustomerVehicle } from 'JS/types/Automotive';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerVehicleSelectorSidebar',
  props: {
    show: { type: Boolean },
    loading: { type: Boolean },
    showOnlyVehicle: { type: Boolean }
  },
  emits: ["close", "select"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'close'): void;
	(event: 'select', vehicle: ICustomerVehicle): void;
}), expose: any, slots: any, attrs: any }) {





function close() {
	emit('close');
}

return { __sfc: true,emit, close, CustomerVehicleSelector, SideMenu, TransitionFade }
}

})